
import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useSnackbar } from "notistack";
import Layout from "../Layout/Layout";
import { APIUrl } from "../../Helper/APIUrl";

function ManagePageBanner() {
  const Token = JSON.parse(localStorage.getItem("tcn"));
  const localStorageUserId = JSON.parse(localStorage.getItem("userid"));
  const { enqueueSnackbar } = useSnackbar();

  const [search, setSearch] = useState("");
  const [pageBanners, setPageBanners] = useState([]);
  const [filteredPageBanners, setFilteredPageBanners] = useState([]);

  const [Id, setId] = useState(0);
  const [PageName, setPageName] = useState("");
  const [PageURL, setPageURL] = useState("");
  const [Image, setImage] = useState("");
  const [ImageFile, setImageFile] = useState(null);
  const [ImagePreview, setImagePreview] = useState("");
  const [IsActive, setIsActive] = useState(true);
  const [MetaTitle, setMetaTitle] = useState("");
  const [MetaDescription, setMetaDescription] = useState("");
  const [MetaKeyword, setMetaKeyword] = useState("");
  const [ImageAltText, setImageAltText] = useState("");

  const [edit, setEdit] = useState(false);

  const PageNameRef = useRef(null);
  const PageURLRef = useRef(null);
  const ImageRef = useRef(null);
  const MetaTitleRef = useRef(null);
  const MetaDescriptionRef = useRef(null);
  const MetaKeywordRef = useRef(null);
  const ImageAltTextRef = useRef(null);

  const parseJSON = async (response) => {
    try {
      const text = await response.text();
      if (!text) return null;
      return JSON.parse(text);
    } catch (err) {
      console.warn("Failed to parse JSON response", err);
      return null;
    }
  };

  const getImageSource = (imagePath) => {
    if (!imagePath) return "";
    if (String(imagePath).startsWith("http")) return imagePath;
    return `${APIUrl.BaseUrl}${imagePath}`;
  };

  const doEmptyStates = () => {
    if (ImagePreview && ImagePreview.startsWith("blob:")) {
      URL.revokeObjectURL(ImagePreview);
    }

    setId(0);
    setPageName("");
    setPageURL("");
    setImage("");
    setImageFile(null);
    setImagePreview("");
    setIsActive(true);
    setMetaTitle("");
    setMetaDescription("");
    setMetaKeyword("");
    setImageAltText("");
    setEdit(false);

    if (ImageRef.current) {
      ImageRef.current.value = "";
    }
  };

  const getAllPageBanner = async () => {
    try {
      const response = await fetch(APIUrl.PageBanner + "GetAllPageBanner", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify({}),
      });

      const result = await parseJSON(response);
      if (result && Array.isArray(result.data)) {
        setPageBanners(result.data);
        setFilteredPageBanners(result.data);
      } else {
        setPageBanners([]);
        setFilteredPageBanners([]);
      }
    } catch (error) {
      console.log(error);
      setPageBanners([]);
      setFilteredPageBanners([]);
    }
  };

  useEffect(() => {
    if (!Token) {
      enqueueSnackbar("Please login first", { variant: "warning" });
      return;
    }

    getAllPageBanner();
  }, []);

  useEffect(() => {
    const result = pageBanners.filter((x) => {
      const pageName = (x.PageName || "").toLowerCase();
      const pageURL = (x.PageURL || "").toLowerCase();
      const metaTitle = (x.MetaTitle || "").toLowerCase();
      const metaDescription = (x.MetaDescription || "").toLowerCase();
      const metaKeyword = (x.MetaKeyword || "").toLowerCase();
      const imageAltText = (x.ImageAltText || "").toLowerCase();
      const txt = search.toLowerCase();
      return (
        pageName.includes(txt) ||
        pageURL.includes(txt) ||
        metaTitle.includes(txt) ||
        metaDescription.includes(txt) ||
        metaKeyword.includes(txt) ||
        imageAltText.includes(txt)
      );
    });

    setFilteredPageBanners(result);
  }, [search, pageBanners]);

  useEffect(() => {
    return () => {
      if (ImagePreview && ImagePreview.startsWith("blob:")) {
        URL.revokeObjectURL(ImagePreview);
      }
    };
  }, [ImagePreview]);

  const handleImageChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const isValidType = ["image/jpeg", "image/jpg", "image/png", "image/webp"].includes(file.type);
    if (!isValidType) {
      enqueueSnackbar("Only JPG, JPEG, PNG, or WEBP files are allowed.", { variant: "warning" });
      event.target.value = "";
      return;
    }

    if (ImagePreview && ImagePreview.startsWith("blob:")) {
      URL.revokeObjectURL(ImagePreview);
    }

    const preview = URL.createObjectURL(file);
    setImageFile(file);
    setImagePreview(preview);
  };

  const validateForm = () => {
    if (!PageName || PageName.trim().length < 2) {
      enqueueSnackbar("Page Name is required.", { variant: "warning" });
      PageNameRef.current?.focus();
      return false;
    }

    if (!PageURL || PageURL.trim().length < 1) {
      enqueueSnackbar("Page URL is required.", { variant: "warning" });
      PageURLRef.current?.focus();
      return false;
    }

    if (!edit && !ImageFile) {
      enqueueSnackbar("Please upload image.", { variant: "warning" });
      ImageRef.current?.focus();
      return false;
    }

    return true;
  };

  const insertPageBanner = async () => {
    try {

      if (!validateForm()) return;

      const payload = {
        PageName,
        PageURL,
        Image: "",
        MetaTitle: MetaTitle.trim(),
        MetaDescription: MetaDescription.trim(),
        MetaKeyword: MetaKeyword.trim(),
        ImageAltText: ImageAltText.trim(),
        IsActive: true,
        CreatedBy: localStorageUserId || 0,
        ModifyBy: localStorageUserId || 0,
      };

      const formData = new FormData();
      formData.append("PageBannerJson", JSON.stringify(payload));

      if (ImageFile) {
        formData.append("Image", ImageFile);
      }

      const response = await fetch(APIUrl.PageBanner + "InsertPageBanner", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: formData,
      });

      const result = await parseJSON(response);

      if (response.ok && result) {
        enqueueSnackbar("Successfully Added", { variant: "success" });
        getAllPageBanner();
        doEmptyStates();
      } else {
        enqueueSnackbar(result?.Message || "Failed to add Page Banner", { variant: "error" });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Error adding Page Banner", { variant: "error" });
    }
  };

  const updatePageBanner = async (_Id) => {
    try {
      if (!validateForm()) return;

      const payload = {
        Id: _Id,
        PageName,
        PageURL,
        Image,
        MetaTitle: MetaTitle.trim(),
        MetaDescription: MetaDescription.trim(),
        MetaKeyword: MetaKeyword.trim(),
        ImageAltText: ImageAltText.trim(),
        IsActive,
        CreatedBy: localStorageUserId || 0,
        ModifyBy: localStorageUserId || 0,
      };

      const formData = new FormData();
      formData.append("PageBannerJson", JSON.stringify(payload));

      if (ImageFile) {
        formData.append("Image", ImageFile);
      }

      const response = await fetch(APIUrl.PageBanner + "UpdatePageBanner/" + _Id, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: formData,
      });

      const result = await parseJSON(response);

      if (response.ok && result) {
        enqueueSnackbar("Successfully Updated", { variant: "success" });
        getAllPageBanner();
        doEmptyStates();
      } else {
        enqueueSnackbar(result?.Message || "Failed to update Page Banner", { variant: "error" });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Error updating Page Banner", { variant: "error" });
    }
  };

  const editPageBanner = (row) => {
    setId(row.Id);
    setPageName(row.PageName || "");
    setPageURL(row.PageURL || "");
    setImage(row.Image || "");
    setImageFile(null);
    setImagePreview(getImageSource(row.Image));
    setIsActive(row.IsActive ?? true);
    setMetaTitle(row.MetaTitle || "");
    setMetaDescription(row.MetaDescription || "");
    setMetaKeyword(row.MetaKeyword || "");
    setImageAltText(row.ImageAltText || "");
    setEdit(true);

    if (ImageRef.current) {
      ImageRef.current.value = "";
    }

    PageNameRef.current?.focus();
  };

  const activateDeactivatePageBanner = async (_Id, Value) => {
    try {
      const response = await fetch(APIUrl.PageBanner + "ActivateDeactivatePageBanner/" + _Id, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify({ Value }),
      });

      const result = await parseJSON(response);

      if (response.ok && result) {
        enqueueSnackbar(Value === "activate" ? "Successfully Activated" : "Successfully Deactivated", {
          variant: Value === "activate" ? "success" : "warning",
        });
        getAllPageBanner();
      } else {
        enqueueSnackbar(result?.Message || "Failed to update status", { variant: "error" });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Error updating status", { variant: "error" });
    }
  };

  const columns = [
    {
      name: "SNo.",
      selector: (_, index) => index + 1,
      maxWidth: "70px",
    },
    {
      name: "Page Name",
      selector: (row) => row.PageName,
      sortable: true,
      grow: 2,
    },
    {
      name: "Page URL",
      selector: (row) => row.PageURL,
      sortable: true,
      grow: 2,
      wrap: true,
    },
    {
      name: "Image",
      grow: 2,
      cell: (row) =>
        row.Image ? (
          <img
            src={getImageSource(row.Image)}
            alt={row.ImageAltText || row.PageName || "Page Banner"}
            className="h-16 w-24 object-cover rounded-md border border-gray-200 my-2"
          />
        ) : (
          <span className="text-xs text-gray-500">No image</span>
        ),
    },
    {
      name: "Status",
      cell: (row) =>
        row.IsActive ? (
          <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Activated</label>
        ) : (
          <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">Deactivated</label>
        ),
      grow: 1,
    },
    {
      name: "Action",
      grow: 1,
      cell: (row) => (
        <div className="flex items-center gap-2 py-2">
          <Button
            onClick={() => editPageBanner(row)}
            className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-2"
            title="Edit Page Banner"
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
          </Button>

          {row.IsActive ? (
            <Button
              onClick={() => activateDeactivatePageBanner(row.Id, "deactivate")}
              className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-3 py-2"
              title="Deactivate Page Banner"
            >
              <i className="fa fa-toggle-on" aria-hidden="true"></i>
            </Button>
          ) : (
            <Button
              onClick={() => activateDeactivatePageBanner(row.Id, "activate")}
              className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-3 py-2"
              title="Activate Page Banner"
            >
              <i className="fa fa-toggle-off" aria-hidden="true"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <Layout>
      <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
        <div className="space-y-6">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-6">Manage Page Banner</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Page Name</label>
                <input
                  ref={PageNameRef}
                  type="text"
                  value={PageName}
                  onChange={(e) => setPageName(e.target.value)}
                  placeholder="Enter Page Name"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Page URL</label>
                <input
                  ref={PageURLRef}
                  type="text"
                  value={PageURL}
                  onChange={(e) => setPageURL(e.target.value)}
                  placeholder="Enter Page URL"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Image Upload</label>
                <input
                  ref={ImageRef}
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Image Alt Text</label>
                <input
                  ref={ImageAltTextRef}
                  type="text"
                  value={ImageAltText}
                  onChange={(e) => setImageAltText(e.target.value)}
                  placeholder="Enter Image Alt Text"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
              {ImagePreview && (
                <div className="mt-4">
                  <p className="text-sm font-medium text-gray-700 mb-2">Image Preview</p>
                  <img
                    src={ImagePreview}
                    alt={ImageAltText || "Preview"}
                    className="h-28 w-44 object-cover rounded-md border border-gray-200"
                  />
                </div>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-6 mt-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Meta Title</label>
                <input
                  ref={MetaTitleRef}
                  type="text"
                  value={MetaTitle}
                  onChange={(e) => setMetaTitle(e.target.value)}
                  placeholder="Enter Meta Title"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Meta Keyword</label>
                <input
                  ref={MetaKeywordRef}
                  type="text"
                  value={MetaKeyword}
                  onChange={(e) => setMetaKeyword(e.target.value)}
                  placeholder="Enter Meta Keyword"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Meta Description</label>
                <textarea
                  ref={MetaDescriptionRef}
                  value={MetaDescription}
                  onChange={(e) => setMetaDescription(e.target.value)}
                  placeholder="Enter Meta Description"
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
            </div>



            <div className="flex flex-col sm:flex-row gap-4 mt-6">
              {!edit ? (
                <Button
                  onClick={insertPageBanner}
                  className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  Add
                </Button>
              ) : (
                <Button
                  onClick={() => updatePageBanner(Id)}
                  className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  Update
                </Button>
              )}

              <button
                type="button"
                onClick={doEmptyStates}
                className="px-6 py-3 bg-gray-600 text-white font-medium rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
              >
                Reset
              </button>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="overflow-x-auto">
              <DataTable
                title="Get All Page Banner"
                columns={columns}
                data={filteredPageBanners}
                pagination
                fixedHeader
                fixedHeaderScrollHeight="550px"
                highlightOnHover
                subHeader
                subHeaderAlign="right"
                subHeaderComponent={
                  <input
                    type="text"
                    placeholder="Search page name / URL / meta"
                    className="w-full sm:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                }
              />
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default ManagePageBanner;
